var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.testSession)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":"","align-center":""}},[_c('v-spacer'),_vm._t("stream-view-menu-custom"),_c('cat-stream-view-chooser')],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }